import * as TYPES from '../action-type';
import { diffUsers } from '../../utils/utils';

export default function user(
  state = {
    users: {
      broker: [],
      manager: [],
      borrower: []
    },
    usersIsGet: false
  },
  action
) {
  switch (action.type) {
    case TYPES.ADD_USER:
      state = JSON.parse(JSON.stringify(state));
      const { role } = action.user;
      state.users[role].push(action.user);
      break;
    case TYPES.SET_USERS:
      state = JSON.parse(JSON.stringify(state));

      state.users = diffUsers(action.users);

      state.usersIsGet = true;

      break;
    default:
      break;
  }
  return state;
}
